import React from "react";
import { LoadingScreen } from "../LoadingScreen";
import { useBIServerStatus } from "../hooks/useBIServerStatus";
import { ConnectionError } from "@/pages/ConnectionError";
import { SvgIcon } from "@/svg";

export function MaintenanceGuard({ children }: React.PropsWithChildren) {
  const status = useBIServerStatus({ fetchEvery: 60000 });

  if (status.isError) {
    return <ConnectionError />;
  }

  if (status.isLoading || !status.isSuccess) {
    return <LoadingScreen />;
  }

  if (!status.data.available) {
    return <Maintenance />;
  }

  return children;
}

function Maintenance() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-pureWhite">
      <div className="flex flex-col items-center space-y-6 gap-y-4">
        <SvgIcon icon="MaintenanceTrip" />
        <div className="font-medium text-[32px] text-center">Maintenance in Progress</div>
      </div>
      <div className="text-feintGray font-medium text-center">We will be back soon!</div>
    </div>
  );
}
